// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   App Shell Skeleton — pixel-perfect to NextPage CSS:
   header: min-height:110px, padding-top:13px, header-bg.jpg
   #hallmark: 50×49px, background-size:42×46px
   #sitename>div: height:41px, color:#009dd9, font-size:20px
   nav#site-specific-nav: background:#0b2d71
   nav li>a: padding:12.5px 19px → ~45px total height
   ========================================================= */

/* ── Wrapper ── */
.shell-skeleton {
  min-height: 100vh;
  background-color: rgb(243, 244, 248);
  display: flex;
  flex-direction: column;
}

/* ── Header (np-header) ──
   NextPage: min-height:110px, padding-top:13px
   Background: header-bg.jpg (same as global styles.css \`header\` rule)
── */
.shell-header {
  min-height: 110px;
  padding-top: 13px;
  background-image: url('/assets/header-bg.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #001E41; /* fallback while image loads */
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* ── #sitename: display:block, margin:0 auto, padding:0 100px ── */
.shell-sitename {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 0 100px;
}

/* ── #hallmark: 50×49px block, background-size:42×46px, margin:0 auto ── */
.shell-hallmark {
  width: 50px;
  height: 49px;
  margin: 0 auto;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.12) 25%,
    rgba(255, 255, 255, 0.24) 50%,
    rgba(255, 255, 255, 0.12) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 3px;
}

/* ── #sitename>div: height:41px, flex-center ── */
.shell-sitename__title {
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Teal shimmer for sitename (matches #009dd9) */
:host ::ng-deep .skl-teal .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(0, 157, 217, 0.30) 25%,
    rgba(0, 157, 217, 0.55) 50%,
    rgba(0, 157, 217, 0.30) 75%
  ) !important;
  background-size: 200% 100% !important;
}

/* ── header-user-info (position:absolute, right:1.5rem) ── */
.shell-header-user {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 0;
}

/* White shimmer for skeleton blocks on dark backgrounds */
:host ::ng-deep .skl-white .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.18) 25%,
    rgba(255, 255, 255, 0.35) 50%,
    rgba(255, 255, 255, 0.18) 75%
  ) !important;
  background-size: 200% 100% !important;
}

:host ::ng-deep .skl-white-dim .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.10) 25%,
    rgba(255, 255, 255, 0.20) 50%,
    rgba(255, 255, 255, 0.10) 75%
  ) !important;
  background-size: 200% 100% !important;
}

:host ::ng-deep .skl-nav .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.15) 25%,
    rgba(255, 255, 255, 0.28) 50%,
    rgba(255, 255, 255, 0.15) 75%
  ) !important;
  background-size: 200% 100% !important;
}

/* ── nav#site-specific-nav ──
   background:#0b2d71 (NextPage exact value)
   li>a: padding:12.5px 19px, font-size:14px → nav height ~45px
── */
.shell-nav {
  background: #0b2d71;
  flex: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-shrink: 0;
  min-height: 45px; /* 12.5px + 21px line-height + 12.5px = 46px — locks height regardless of font rendering */
}

.shell-nav__item {
  flex: 1 auto;
  margin: 0 15px;
  padding: 12.5px 19px; /* exact li>a padding from NextPage */
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ── Content area ── */
.shell-content {
  flex: 1;
  padding-top: 16px;
}

/* Card primitives */
.shell-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.shell-card__header {
  padding: 10px 16px;
  border-bottom: 1px solid #dee2e6;
  background: #ffffff;
  min-height: 44px;
  display: flex;
  align-items: center;
}

.shell-card__header--blue {
  background: #0066B2 !important;
  border-bottom: none !important;
}

.shell-card__body {
  padding: 16px;
  flex: 1;
}

/* 3-column KPI grid inside the strategy card */
.shell-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.shell-kpi-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 18px 16px;
}

/* Table rows inside candidate cards */
.shell-table-row {
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* ── Shimmer keyframes (re-declared for host scope) ── */
@keyframes shimmer {
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
}

/* ── Responsive ── */
@media (max-width: 767.98px) {
  .shell-sitename {
    padding: 0 60px; /* NextPage mobile: padding:0 60px */
  }

  .shell-hallmark {
    /* NextPage mobile: background-size:36px 40px */
    width: 42px;
    height: 44px;
  }

  .shell-header-user {
    display: none; /* matches .header-user-info @media max-width:576px display:none */
  }

  .shell-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/app-shell-skeleton/app-shell-skeleton.component.css"],"names":[],"mappings":"AAAA;;;;;;;8DAO8D;;AAE9D,kBAAkB;AAClB;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;IAGI;AACJ;EACE,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB,EAAE,+BAA+B;EAC1D,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd;;;;;GAKC;EACD,0BAA0B;EAC1B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,MAAM;AACR;;AAEA,0DAA0D;AAC1D;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA;EACE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA;;;IAGI;AACJ;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,gBAAgB,EAAE,0FAA0F;AAC9G;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB,EAAE,qCAAqC;EAC3D,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe,EAAE,oCAAoC;EACvD;;EAEA;IACE,+CAA+C;IAC/C,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa,EAAE,kEAAkE;EACnF;;EAEA;IACE,gDAAgD;EAClD;AACF","sourcesContent":["/* =========================================================\n   App Shell Skeleton — pixel-perfect to NextPage CSS:\n   header: min-height:110px, padding-top:13px, header-bg.jpg\n   #hallmark: 50×49px, background-size:42×46px\n   #sitename>div: height:41px, color:#009dd9, font-size:20px\n   nav#site-specific-nav: background:#0b2d71\n   nav li>a: padding:12.5px 19px → ~45px total height\n   ========================================================= */\n\n/* ── Wrapper ── */\n.shell-skeleton {\n  min-height: 100vh;\n  background-color: rgb(243, 244, 248);\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Header (np-header) ──\n   NextPage: min-height:110px, padding-top:13px\n   Background: header-bg.jpg (same as global styles.css `header` rule)\n── */\n.shell-header {\n  min-height: 110px;\n  padding-top: 13px;\n  background-image: url('/assets/header-bg.jpg');\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: #001E41; /* fallback while image loads */\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/* ── #sitename: display:block, margin:0 auto, padding:0 100px ── */\n.shell-sitename {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n  padding: 0 100px;\n}\n\n/* ── #hallmark: 50×49px block, background-size:42×46px, margin:0 auto ── */\n.shell-hallmark {\n  width: 50px;\n  height: 49px;\n  margin: 0 auto;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.12) 25%,\n    rgba(255, 255, 255, 0.24) 50%,\n    rgba(255, 255, 255, 0.12) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s ease-in-out infinite;\n  border-radius: 3px;\n}\n\n/* ── #sitename>div: height:41px, flex-center ── */\n.shell-sitename__title {\n  height: 41px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Teal shimmer for sitename (matches #009dd9) */\n:host ::ng-deep .skl-teal .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(0, 157, 217, 0.30) 25%,\n    rgba(0, 157, 217, 0.55) 50%,\n    rgba(0, 157, 217, 0.30) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n/* ── header-user-info (position:absolute, right:1.5rem) ── */\n.shell-header-user {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 0;\n}\n\n/* White shimmer for skeleton blocks on dark backgrounds */\n:host ::ng-deep .skl-white .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.18) 25%,\n    rgba(255, 255, 255, 0.35) 50%,\n    rgba(255, 255, 255, 0.18) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n:host ::ng-deep .skl-white-dim .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.10) 25%,\n    rgba(255, 255, 255, 0.20) 50%,\n    rgba(255, 255, 255, 0.10) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n:host ::ng-deep .skl-nav .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    rgba(255, 255, 255, 0.28) 50%,\n    rgba(255, 255, 255, 0.15) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n/* ── nav#site-specific-nav ──\n   background:#0b2d71 (NextPage exact value)\n   li>a: padding:12.5px 19px, font-size:14px → nav height ~45px\n── */\n.shell-nav {\n  background: #0b2d71;\n  flex: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex-shrink: 0;\n  min-height: 45px; /* 12.5px + 21px line-height + 12.5px = 46px — locks height regardless of font rendering */\n}\n\n.shell-nav__item {\n  flex: 1 auto;\n  margin: 0 15px;\n  padding: 12.5px 19px; /* exact li>a padding from NextPage */\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ── Content area ── */\n.shell-content {\n  flex: 1;\n  padding-top: 16px;\n}\n\n/* Card primitives */\n.shell-card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.shell-card__header {\n  padding: 10px 16px;\n  border-bottom: 1px solid #dee2e6;\n  background: #ffffff;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n.shell-card__header--blue {\n  background: #0066B2 !important;\n  border-bottom: none !important;\n}\n\n.shell-card__body {\n  padding: 16px;\n  flex: 1;\n}\n\n/* 3-column KPI grid inside the strategy card */\n.shell-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.shell-kpi-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 18px 16px;\n}\n\n/* Table rows inside candidate cards */\n.shell-table-row {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 60px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/* ── Shimmer keyframes (re-declared for host scope) ── */\n@keyframes shimmer {\n  0%   { background-position: -200% 0; }\n  100% { background-position:  200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 767.98px) {\n  .shell-sitename {\n    padding: 0 60px; /* NextPage mobile: padding:0 60px */\n  }\n\n  .shell-hallmark {\n    /* NextPage mobile: background-size:36px 40px */\n    width: 42px;\n    height: 44px;\n  }\n\n  .shell-header-user {\n    display: none; /* matches .header-user-info @media max-width:576px display:none */\n  }\n\n  .shell-kpi-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
